const BASKET_KEY = "filter";

class FilterController {
  constructor() {
    this.options = JSON.parse(sessionStorage.getItem(BASKET_KEY)) ?? {};
  }

  set options(options) {
    sessionStorage.setItem(BASKET_KEY, JSON.stringify(options));
  }

  get options() {
    return JSON.parse(sessionStorage.getItem(BASKET_KEY)) ?? {};
  }

  setOptions(options) {
    this.options = options;
  }

  clearOptions() {
    this.options = {};
  }
}

export default new FilterController();
